import React, {Component} from 'react';
import bkilogombl from '../../commons/images/bki-logo-mbl1.svg';
import edIom from '../../commons/pdfs/EQ-IOM.pdf';
import shopDrawing from '../../commons/pdfs/FD-Shop_Drawing.pdf';
import submittal from '../../commons/pdfs/FD-Submittal.pdf';
import preview from '../../commons/images/preview.png';

class BKIDocument extends Component {
    constructor(props){
        super(props)

        this.state= {
            equipment_labels: [
                {key: 'Equipment Submittal', value: edIom}, {key: 'Equipment Installation and Operation Manuals', value: shopDrawing}, {key: 'Equipment Start-up forms', value: submittal}, {key:'Commissioning Checklists', value: 4}, {key: 'Test & Balance', value : 5} ],
            duct_insp: [
                {key:'Shop drawing of the area in question', value: 6}, {key:'Photos with dates of the duct showing it clean at install', value: 7} ],
            life_safety: [
                {key:'Shop drawing of the area in question showing the damper location', value: 8}, {key:'Damper Submittals', value: 9}, {key:'Signed off Damper Commissioning', value: 10} ]
        }
    }

    
    render(){
        let url = this.props.location.pathname.slice(1)
        let title = url === 'equipment_labels' ? 'Equipment Labels' : (url === 'duct_insp' ? 'Duct Cleanliness Inspection' : 'Life Safety Dampers')
        return(
            <div>
                <div className="doc-link">
                    <img src={bkilogombl} alt="logo" className="document-bki-logo" />
                </div>
                <h4 className= 'title'>{title}</h4>
                <div className="document-list">
                    {/* <div className="mobile-view"> */}
                        <div className='list-wrap'>
                            { this.state[url].map((object, index) => {
                                return(
                                    <React.Fragment key={index}>
                                        <div className='list-name d-flex align-items-center justify-content-between'>
                                            <div className= 'name-column d-flex justify-content-between flex-column'>
                                                <span className="doc-name">{object.key}</span>
                                            </div>
                                            <div className='download-icon'>
                                                <a href={`${object.value}`} target='_blank'>
                                                    <img src={preview} alt="No_Image" />
                                                </a>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                                })
                            }
                        </div>
                    {/* </div> */}
                    {/* taskboard blocks for design */}
                    <div className="desktop-view">
                        {/* {this._renderGroups()} */}
                    </div>
                </div>
            </div>
        )
    }
}
export default BKIDocument;